import React, { useEffect, useState } from "react";

const PdfViewer = ({ fileId, onBack }) => {
  const [loading, setLoading] = useState(true);
  const PDF_URL = window.API_BASE_URL + "pdf";
  const pdfUrl = `${PDF_URL}/${fileId}`;
  const viewerUrl = `/pdfjs/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`;

//  // ✅ Wait for the custom message from the PDF.js iframe
//  useEffect(() => {
//    const handleMessage = (event) => {
//      console.log("received event");
//      if (event.data?.type === "pdf-loaded") {
//        console.log("📩 Received pdf-loaded from iframe");
//        setLoading(false);      // hide overlay only when actual PDF is ready
//      }
//    };
//    window.addEventListener("message", handleMessage);
//    return () => window.removeEventListener("message", handleMessage);
//  }, []);
  
  
useEffect(() => {
  const interval = setInterval(() => {
    const frame = document.querySelector("iframe");
    const doc = frame?.contentDocument;
    const pageCanvas = doc?.querySelector(".page canvas"); // first page canvas
    if (pageCanvas) {
      //console.log("Detected first page rendered");
      setLoading(false);
      clearInterval(interval);
    }
  }, 500);

  return () => clearInterval(interval);
}, []);

  return (
    <div className="w-full h-screen flex flex-col bg-gray-100 relative">
      {/* Header with back button */}
      <div className="flex items-center justify-between bg-gray-800 text-white px-4 py-2">
        <button
          onClick={onBack}
          className="bg-gray-600 hover:bg-gray-700 px-3 py-1 rounded text-sm"
        >
          ← Back
        </button>
        <h2 className="text-lg font-semibold">PDF Viewer</h2>
        <div />
      </div>

      {/* Loading overlay 
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-200 bg-opacity-75 z-10">
          <p className="text-lg font-medium">Loading PDF...</p>
        </div>
      )}*/}
      
{loading && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-lg shadow p-6 flex flex-col items-center">
      <svg className="animate-spin h-8 w-8 text-blue-600 mb-3" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
      </svg>
      <p className="text-gray-700">Loading PDF...</p>
    </div>
  </div>
)}       
      

      {/* Iframe */}
      <iframe
        src={viewerUrl}
        title="PDF Viewer"
        className="flex-1 w-full"
      />
    </div>
  );
};

export default PdfViewer;
